import React, { useEffect, useState } from "react";
import Table from "../../constants/Table";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "../../App.css";

const UserManagement = () => {
  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
const [showPassword, setShowPassword] = useState(false);

  
  const [loading, setLoading] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem("user_details"));
// console.log(userDetails,"userDetails")
  const [newUser, setNewUser] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    mobile: "",
    role: "",
    password: "",
  });

  const clearForm = () => {
    setNewUser({
      first_name: "",
      middle_name: "",
      last_name: "",
      email: "",
      mobile: "",
      role: "",
      password: "",
    });
  };

const handleShow = () => {
  setIsEdit(false);
  setEditId(null);

  // Reset everything to empty values
  setNewUser({
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    mobile: "",
    role: "",    
    password: "",
  });

  setShow(true);
};


  const handleClose = () => setShow(false);

  const handleChange = (e) => {
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      const payload = {
        first_name: newUser.first_name,
        middle_name: newUser.middle_name || "",
        last_name: newUser.last_name || "",
        email: newUser.email,
        phone_number: newUser.mobile,
        role: newUser.role,
        company_profile_id: userDetails.company_profile_id,
      };

      // Password always included only if user typed it
      if (newUser.password.trim() !== "") {
        payload.password = newUser.password;
      }
console.log(editId,"editId")
      let res;
      if (isEdit) {
        res = await apicall.post(payload, `updateUsers/${editId}`);
        if (res.success) toast.success("User updated successfully!");
        window.location.reload();
      } else {
        res = await apicall.post(payload, "users");
        if (res.success) toast.success("User added successfully!");
      }

      getUsers();
      handleClose();
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const getUsers = async () => {
    setLoading(true);
    try {
            // const res = await apicall.get(`get_vendors?category=${encodeURIComponent(category)}`);
      
      const res = await apicall.get(`users?company_profile_id=${userDetails?.company_profile_id}`);
      setUsers(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };

    const getUsersrole = async () => {
    setLoading(true);
    try {
      const res = await apicall.get("roles");
      setRoles(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getUsers();
    getUsersrole();
  }, []);

  const handleEdit = (user) => {
    setIsEdit(true);
    setEditId(user.id);

    setNewUser({
      first_name: user.first_name,
      middle_name: user.middle_name || "",
      last_name: user.last_name || "",
      email: user.email,
      mobile: user.phone_number,
      role: user.role,
      password: "", // DO NOT PREFILL
    });

    setShow(true);
  };

  const bookingHeaders = [
    "First Name",
    "Middle Name",
    "Last Name",
    "Email",
    "Mobile",
    "Role",
    "Status",
    "Action",
  ];

const usersData = users?.map((item) => [
  item.first_name,
  item.middle_name ? item.middle_name : "-",
  item.last_name ? item.last_name : "-",
  item.email,
  item.phone_number,
  item.role_name,
  item.is_active === "1" ? "Active" : "In-Active",
  userDetails?.is_primary_user === 1 ? (
    <button
      className="btn btn-sm btn-outline-danger"
      onClick={() => handleEdit(item)}
    >
      Edit
    </button>
  ) : (
    "-"
  ),
]);


  return (
    <div className="p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 >User Management</h5>

        {userDetails?.is_primary_user === 1 && (
          <button className="btn btn-danger" onClick={handleShow}>
            Add User
          </button>
        )}
      </div>

      <Table
        headers={bookingHeaders}
        data={usersData}
        pagination={true}
        recordsCount={10}
      />

      <Modal
        show={show}
        onHide={handleClose}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="custom-user-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit User" : "Add User"}</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <div className="mb-3">
            <label className="form-label">First Name</label>
            <input
              type="text"
              className="form-control"
              name="first_name"
              value={newUser.first_name}
              onChange={handleChange}
              placeholder="Enter first name"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Middle Name</label>
            <input
              type="text"
              className="form-control"
              name="middle_name"
              value={newUser.middle_name}
              onChange={handleChange}
              placeholder="Enter middle name"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Last Name</label>
            <input
              type="text"
              className="form-control"
              name="last_name"
              value={newUser.last_name}
              onChange={handleChange}
              placeholder="Enter last name"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={newUser.email}
              onChange={handleChange}
              placeholder="Enter email"
              disabled={isEdit}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Mobile</label>
            <input
              type="text"
              className="form-control"
              name="mobile"
              value={newUser.mobile}
              onChange={handleChange}
              placeholder="Enter mobile number"
            />
          </div>

          {/* Only show role in edit mode — remove from Add */}
          {/* {isEdit && ( */}
            <div className="mb-3">
              <label className="form-label">Role</label>
              <select
  className="form-control"
  name="role"
  value={newUser.role}
  onChange={handleChange}
  disabled={isEdit}
>
  <option value="">Select Role</option>

  {roles?.map((item) => (
    <option key={item.name} value={item.id}>
      {item.name}
    </option>
  ))}
</select>

            </div>
          {/* )} */}

        {/* Password only in ADD mode */}
{!isEdit && (
  <div className="mb-3 position-relative">
    <label className="form-label">Password</label>

    <input
      type={showPassword ? "text" : "password"}
      className="form-control"
      name="password"
      value={newUser.password}
      onChange={handleChange}
      placeholder="Enter password"
    />

    <span
      className="position-absolute"
      style={{
        right: "15px",
        top: "40px",
        cursor: "pointer",
        fontSize: "18px",
      }}
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? (
        <i className="fa fa-eye-slash"></i>
      ) : (
        <i className="fa fa-eye"></i>
      )}
    </span>
  </div>
)}

        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleSave}>
            {isEdit ? "Update" : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserManagement;
